import React, { Fragment, useEffect, useState } from "react";
import { Settings } from "react-feather";
import { Link } from "react-router-dom";
import { H6, Image, LI, UL, P } from "../../AbstractElements";
import man from "../../assets/images/dashboard/1.png";
import "./styles.css";
import axios from "axios";

const Profile = () => {
	const candidateId = sessionStorage.getItem("candidateId");
	let isProfilePicUploaded = false;
	const API_BASE_URL = window.appConfig.API_BASE_URL;

	const [user, setUser] = useState({
		name: "",
		surname: "",
		gender: "",
		currentJobTitle: "",
	});

	const { name, surname, gender, currentJobTitle } = user;

	useEffect(() => {
		const loadUser = async () => {
			const email = sessionStorage.getItem("email");

			const result = await axios.get(
				`${API_BASE_URL}/Candidate/GetByEmail?email=${email}`
			);

			isProfilePicUploaded = result.data.avatar != null;
			setUser(result.data);
		};
		loadUser();
	}, []);

	return (
		<Fragment>
			{/* <Image
				attrImage={{
					className: "skilledup",
					src: `/skilled-up-logo.svg`,
					alt: "",
				}}
			/> */}
			<div className="sidebar-user text-center">
				{user.avatar != null && (
					<img
						className={"img-90 rounded-circle user-pfp"}
						src={`${API_BASE_URL}/Candidate/GetAvatar/${candidateId}`}
					/>
				)}
				<H6
					attrH6={{
						className: "mt-3 f-14 f-w-600",
						id: "profile-header",
					}}
				>
					{`${name}${" "}${surname}`}
				</H6>
				<P
					attrPara={{
						className: "mb-0 font-roboto",
					}}
				>
					{currentJobTitle}
				</P>
			</div>
		</Fragment>
	);
};

export default Profile;
